<template>
  <div class="business-area-selected">
    <el-button size="mini" class="add" @click="handleAdd"> 添加</el-button>

    <template v-if="businessAreaSelected.length === this.getAreaJson.length">
      <el-button size="mini" class="selected" @click="handleClear">
        全国 <i class="iconfont icon-close-sm"></i>
      </el-button>
    </template>

    <template v-else>
      <el-button
        size="mini"
        :key="key"
        v-for="(item, key) in businessAreaSelected"
        class="selected"
        @click="handleDelete(item, key)"
      >
        {{ item.text }} <i class="iconfont icon-close-sm"></i>
      </el-button>
    </template>

    <!-- 选择器 -->
    <BusinessAreaSelector v-if="isShowBusinessAreaSelector" />
  </div>
</template>

<script>
import BusinessAreaSelector from "@/components/LayoutHeaderSearch/components/DialogSmartSubscribe/BusinessAreaSelector";
import { getAreaJson } from "@/assets/areaJSON";

export default {
  name: "BusinessAreaSelected",
  components: { BusinessAreaSelector },
  computed: {
    businessAreaSelected() {
      return this.$store.getters["industryZone/businessAreaSelected"];
    },
    isShowBusinessAreaSelector() {
      return this.$store.getters["industryZone/isShowBusinessAreaSelector"];
    },
    getAreaJson,
  },
  methods: {
    handleAdd() {
      this.$store.commit("industryZone/updateIsShowBusinessAreaSelector", true);
    },
    handleDelete(item) {
      const businessAreaSelected = this.businessAreaSelected;
      const afterDeleted = businessAreaSelected.filter((v) => v.id !== item.id);
      this.$store.commit(
        "industryZone/updateBusinessAreaSelected",
        afterDeleted
      );
    },
    handleClear() {
      this.$store.commit("industryZone/updateBusinessAreaSelected", []);
    },
  },
};
</script>

<style lang="scss">
.business-area-selected {
  .add {
    padding: 7px 10px !important;
    margin: 0 10px 10px 0 !important;

    span {
      line-height: 16px;
    }
  }

  .selected {
    padding: 7px 5px 7px 10px !important;
    margin: 0 10px 10px 0 !important;

    span {
      line-height: 16px;
      display: flex;
      align-items: center;
    }
  }
}
</style>

<style scoped lang="scss">
@import "../../../../assets/config";

.business-area-selected {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}
</style>
